import { getBaseUrl, isMagnoliaPreview } from '../../../shared/utils';

const NO_REFERRAL_PARAM = 'no_referral';

function isNoReferral(search: string = globalThis.location.search): boolean {
  return new URLSearchParams(search).get(NO_REFERRAL_PARAM) === 'true';
}

function navigateToNoReferralResultsPage() {
  const destination = isMagnoliaPreview()
    ? `${globalThis.location.origin}/magnolia-wrapper/results`
    : `${getBaseUrl()}/taxes/results`;
  globalThis.location.href = `${destination}?source=matcher&synthetic_monitor=true`;
}

export { isNoReferral, navigateToNoReferralResultsPage };
